((window, document) => {
    const hero = document.querySelector('.hero-v2')

    if (!hero)
        return

    const scroll = hero.querySelector('.hero-v2__scroll')
    const headline = hero.querySelector('.hero-v2__headline')
    const intro = hero.querySelector('.hero-v2__intro')
    const overlayOpacity = 0.3
    const headlineFoot = 93
    // viewport fraction the hero's end sits below the screen when the bar is full
    const revealEnd = 0.05

    // ie11 keeps the plain one-screen hero. overflow-x: clip is what lets
    // sticky work at all here - see the note in _hero.scss
    const canPin = Boolean(scroll)
        && Boolean(headline)
        && Boolean(window.matchMedia)
        && Boolean(window.CSS && window.CSS.supports)
        && window.CSS.supports('position', 'sticky')
        && window.CSS.supports('overflow-x', 'clip')
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches

    let ticking = false
    let lastOffset = null
    let lastHeight = null
    let heroTop = 0
    let exitDistance = 0

    /**
    * Scroll Position
    * @return {Integer}
    */
    function scrollTop () {
        return window.pageYOffset
            || document.documentElement.scrollTop
            || 0
    }

    /**
    * Fill the Viewport Below the Header and Popup Banner
    * Either may be absent or animating, so measure rather than subtract a
    * constant.
    * @return {Void}
    */
    function measure () {
        const offset = Math.round(
            hero.getBoundingClientRect().top + scrollTop())

        heroTop = offset

        // a resize changes the first screen without moving the hero
        if (offset === lastOffset && window.innerHeight === lastHeight)
            return

        lastOffset = offset
        lastHeight = window.innerHeight

        const firstScreen = window.innerHeight - offset

        hero.style.minHeight = `${firstScreen}px`

        if (!canPin)
            return

        // the first screen is a viewport less the header, not the full viewport
        // the pin is sized to
        const rest = Math.max(0, Math.round(
            firstScreen - headlineFoot - headline.offsetHeight))

        scroll.style.paddingTop = `${rest}px`

        // the handover is the headline clearing the top of the screen, and the
        // overlay is fully drawn by then - the runway runs well past it
        exitDistance = rest + headline.offsetHeight
    }

    /**
    * Paint the Overlay for the Current Scroll Position
    * @return {Void}
    */
    function paint () {
        ticking = false

        // grows from the intro reaching mid-screen to the hero's end
        const height = window.innerHeight
        const text = intro || headline
        const toEnd = hero.getBoundingClientRect().bottom - height

        let reveal = 0

        if (text) {
            const bounds = text.getBoundingClientRect()
            const toStart = (bounds.top + (bounds.height / 2)) - (height / 2)
            const span = (toEnd - toStart) - (revealEnd * height)

            reveal = (span > 0)
                ? Math.min(Math.max(-toStart / span, 0), 1)
                : (toStart <= 0 ? 1 : 0)
        }

        hero.style.setProperty(
            '--hero-reveal', (1 - Math.pow(1 - reveal, 2)).toFixed(3))

        hero.style.setProperty(
            '--hero-hours', Math.max(1 - (reveal * 3), 0).toFixed(3))

        if (exitDistance <= 0)
            return

        const travelled = scrollTop() - heroTop
        const progress = Math.min(Math.max(
            travelled / exitDistance, 0), 1)

        hero.style.setProperty(
            '--hero-overlay', (progress * overlayOpacity).toFixed(3))
    }

    /**
    * Queue a Paint on the Next Frame
    * @return {Void}
    */
    function request () {
        if (ticking)
            return

        ticking = true

        window
            .requestAnimationFrame(paint)
    }

    measure()

    if (canPin) {
        document.documentElement.classList.add('hero-v2-pinned')
        hero.classList.add('hero-v2_pinned')

        paint()

        window
            .addEventListener('scroll',
                request)

        // a hidden tab stops serving frames, so scrolling away and coming back
        // would otherwise leave the overlay on the position we left
        document
            .addEventListener('visibilitychange', () => {
                if (!document.hidden)
                    request()
            })
    }

    window
        .addEventListener('load',
            measure)

    window
        .addEventListener('resize', () => {
            measure()
            request()
        })

    // the popup banner ends its open/close animation with a bubbling transitionend
    document
        .addEventListener('transitionend',
            measure)
})(window, document)
